import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  BranchListRequest,
  BranchListResponse,
  Branch,
  BranchShortListRequest,
  BranchShortListResponse,
  BranchCreateRequest,
  BranchUpdateRequest,
} from "./types";

/**
 * List
 */
export const branchListService = (params: BranchListRequest) =>
  RestAPIClient.call<BranchListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * List short
 */
export const branchListShortService = (params: BranchShortListRequest) =>
  RestAPIClient.call<BranchShortListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Detail
 */
export const branchDetailService = (id: number) =>
  RestAPIClient.call<Branch>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const branchCreateService = (data: BranchCreateRequest) =>
  RestAPIClient.call<Branch>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update
 */
export const branchUpdateService = (data: BranchUpdateRequest) =>
  RestAPIClient.call<Branch>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });
